class SimpleCountdown {
    constructor(element) {

        this.dateTime = element.dataset.simpleCountdown;
        if (this.dateTime) {
            this.elDays = element.querySelector('.days');
            this.elHours = element.querySelector('.hours');
            this.elMinutes = element.querySelector('.minutes');

            this.countDownDate = new Date(this.dateTime).getTime();

            this.updateTime();

            this.x = setInterval(() => {
                this.updateTime(this.x);
            }, 1000);
        }
    }

    updateTime (x) {
        let now = new Date().getTime();
        let distance = this.countDownDate - now;
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

        this.elDays.innerHTML = days > 0 ? days.toString() : '0';
        this.elHours.innerHTML = hours > 0 ? hours.toString() : '0';
        this.elMinutes.innerHTML = minutes > 0 ? minutes.toString() : '0';

        if (x && distance < 0) {
            clearInterval(x);
        }
    }

    static init() {
        const elements = document.querySelectorAll(
            "[data-simple-countdown]"
        );

        elements.forEach((el) => {
            new SimpleCountdown(el);
        });
    }
}

export default SimpleCountdown
